module.exports = __webpack_public_path__ + "img/bambu-logo.daa4f2c0.png";